import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { GoVerified } from 'react-icons/go';
import { toast } from 'react-toastify';
import adsTracking from '../../utils/adsTracking';
import { Button, Container, ContentImg, NavLit, PaidPlanInfo } from './styles';
import { redirectToLtiCourseIfExists } from '../../utils/functions';
import { gateway } from '../../utils/api';
import history from '../../utils/history';
import { fetchOnboardingPages } from '../../business/onboarding';
import { goToHomeOrTurma } from '../../utils/homeRedirect';

import IMG_LIT from '../../images/lit.png';

function ThankYou({ match, location }) {
  const tenant = localStorage.getItem('tenant');
  const [isOnboardCompleted, setIsOnboardCompleted] = useState(false);
  const [onboardingStatusChecked, setOnboardingStatusChecked] = useState(false);
  const [redirectingToHome, setRedirectingToHome] = useState(false);
  const [thankYouPageMessage, setThankYouPageMessage] = useState({
    title: '',
    text: '',
    planInfo: true
  });
  const { plan } = match.params;
  const {
    paidPlan = {},
    paymentMethod = '',
    paidValue = 0,
    paymentResult = {},
    contractCode = ''
  } = location.state || {};

  const companyText = async () => {
    try {
      const message = await gateway.get(
        `/webbff/lit_app_web/payment/plan/thankYouPage?classificationPlan=${paymentResult.classificationPlan}`
      );
      setThankYouPageMessage({
        title: (message && message.data && message.data.title) || '',
        text: (message && message.data && message.data.text) || '',
        planInfo: (message && message.data && message.data.planInfo !== undefined) 
          ? message.data.planInfo 
          : true
      });
    } catch (error) {
      console.error('Erro ao buscar mensagem da página de agradecimento:', error);
      // Mantém os valores padrão já definidos no useState
    }
  };

  const checkOnboardingStatus = async () => {
    try {
      const response = await fetchOnboardingPages();
      
      if (!response || !Array.isArray(response) || response.length === 0) {
        // Se não houver steps, considera como completo
        return true;
      }

      // Verifica se há steps incompletos que são obrigatórios
      const hasIncompleteRequiredSteps = response.some(
        step => step.bf_concluded !== true && step.bf_required === true
      );

      // Se houver steps incompletos obrigatórios, onboarding não está completo
      return !hasIncompleteRequiredSteps;
    } catch (error) {
      console.error('Erro ao verificar status do onboarding:', error);
      // Em caso de erro, retorna null para usar o fallback do parâmetro da URL
      return null;
    }
  };

  const paymentMethods = {
    CREDIT: 'Cartão de Crédito',
    PIX: 'Pix',
    INVOICE: 'Boleto',
    BILLED: 'Plano gratuito'
  };

  const handlePaidPrice = useCallback(() => {
    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    });
    return formatter.format(paidValue || 0);
  }, [paidValue]);

  const eCommerceEvent = (plan, paidValue, contractCode, response) => {
    const { transactionCode } = response;
    const tenant = localStorage.getItem('tenant');
    if (tenant && (tenant === 'LIT_BUSINESS' || tenant === 'SAINTPAUL')) {
      const eventName =
        tenant === 'LIT_BUSINESS' ? 'purchase_LIT' : 'purchase_SAINTPAUL';
      adsTracking.sendGoogleAnalyticsEcommerceEvent({
        eventName,
        step: {
          id: contractCode,
          revenue: paidValue,
          /** validar se esta é a melhor forma de pegar o cupom de desconto  */
          coupon: _.get(plan, 'claims.0', '')
        },
        products: [
          {
            name: plan.name,
            id: plan.code,
            price: paidValue,
            brand: 'LIT',
            // category: adsTracking.CATEGORY_DEFAULT,
            quantity: 1
          }
        ],
        transactionCode
      });
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const onboardIsCompletedParam = urlParams.get('onboardIsCompleted');
    const onboardIsCompletedFromUrl = onboardIsCompletedParam === 'true';

    // Inicializa com o valor da URL enquanto verifica o status real
    setIsOnboardCompleted(onboardIsCompletedFromUrl);

    // Verifica o status real do onboarding
    checkOnboardingStatus().then(onboardingCompleted => {
      if (onboardingCompleted !== null) {
        // Prioriza a verificação real dos steps sobre o parâmetro da URL
        setIsOnboardCompleted(onboardingCompleted);
      }
      // Se retornar null, mantém o valor da URL que já foi definido acima
      setOnboardingStatusChecked(true);
    });

    eCommerceEvent(paidPlan, paidValue, contractCode, paymentResult);
    companyText();

    if (onboardIsCompletedFromUrl) {
      const timer = setTimeout(() => {
        redirectToLtiCourseIfExists();
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, []);

  // useEffect separado para mostrar o popup quando o onboarding não estiver completo
  useEffect(() => {
    // Só mostra o popup após a verificação do status do onboarding estar completa
    // e se o onboarding não estiver completo e não for INTERPLAYERS
    // Mostra para planos corporativos ou extensões quando há onboarding pendente
    if (
      onboardingStatusChecked &&
      !isOnboardCompleted &&
      tenant !== 'INTERPLAYERS' &&
      (paidPlan.isExtension || plan === 'corporativo')
    ) {
      const text = (
        <p style={{ color: '#fff' }}>
          Sua jornada ainda não terminou! Clique em &lsquo;Iniciar
          Onboarding&rsquo; e preencha os dados a seguir para finalizar sua
          matrícula
        </p>
      );

        toast.success(text, {
          icon: false,
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            background: '#7ae190'
          },
          theme: 'colored'
        });
    }
  }, [onboardingStatusChecked, isOnboardCompleted, tenant, paidPlan.isExtension, plan]);
    
  function logout() {
    history.push('/logout');
  }

  // Mesma regra do login: com turma vai para /turma (portal next), senão /home.
  // Ir direto para /home deixava o aluno na home antiga, pois a Home só
  // redireciona para /turma quando já existe selectedClassName.
  async function handleGoToHome(e) {
    e.preventDefault();
    if (redirectingToHome || redirectToLtiCourseIfExists()) return;
    setRedirectingToHome(true);
    await goToHomeOrTurma();
  }

  return (
    <>
      <NavLit className="navbar navbar-lit navbar-expand-lg bg-gradient-lit">
        <a className="navbar-brand">
          <img src={IMG_LIT} alt="logo_lit" style={{ width: '100px' }} />
        </a>
        <button type="button" onClick={() => logout()}>
          SAIR
        </button>
      </NavLit>
      <Container>
        <div className="row justify-content-md-center">
          <div className="col-md-6 col-12 rounded">
            <div className="p-2">
              <ContentImg>
                <GoVerified />
              </ContentImg>

              <h4>{thankYouPageMessage.title}</h4>

              {paidValue > 0 && thankYouPageMessage.planInfo && (
                <div className="mt-4 mb-5">
                  <PaidPlanInfo>Plano: {paidPlan.name}</PaidPlanInfo>
                  <PaidPlanInfo>
                    Forma de pagamento: {paymentMethods[paymentMethod]}
                  </PaidPlanInfo>
                  <PaidPlanInfo>Valor: {handlePaidPrice()}</PaidPlanInfo>
                </div>
              )}

              {plan === 'corporativo' && tenant !== 'INTERPLAYERS' && (
                <div className="mt-4 mb-5">
                  {isOnboardCompleted ? (
                    <p>
                      Boas-vindas ao LIT. Clique no botão abaixo para começar:
                    </p>
                  ) : (
                    <p>
                      Você ainda precisa preencher alguns dados nas telas a
                      seguir. Clique no botão abaixo para começar.
                    </p>
                  )}
                  {paidValue > 0 && (
                    <p>
                      Lembrando que sua Nota Fiscal só poderá ser emitida após
                      finalizar seu cadastro.
                    </p>
                  )}
                </div>
              )}

              {tenant === 'INTERPLAYERS' && (
                <div className="mt-4 mb-5">{thankYouPageMessage.text}</div>
              )}

              {isOnboardCompleted ? (
                <a href="/home" onClick={handleGoToHome} style={{ cursor: 'pointer' }}>
                  <Button>Ir para a home</Button>
                </a>
              ) : (
                <a href="/onboarding">
                  <Button>Iniciar Onboarding</Button>
                </a>
              )}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}

export default ThankYou;
